module.exports = __webpack_public_path__ + "img/logo.193b8fcc.svg";